import React from 'react';
import ContentFotoUploadZone from './ContentFotoUploadZone';

/**
 * Seçili parçalara tek foto uygulama — yalnızca görsel seçimi.
 */
export default function ParcaBulkFotoModal({
  isOpen,
  selectedCount = 0,
  previewUrl,
  selectedFile,
  confirmBusy = false,
  onClose,
  onFileSelected,
  onClearFile,
  onConfirm,
}) {
  if (!isOpen) return null;

  const hasNewFoto = selectedFile instanceof File;

  return (
    <div
      className="modal-overlay parca-bulk-foto-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="parca-bulk-foto-title"
      onClick={(e) => {
        if (confirmBusy) return;
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-content parca-bulk-foto-modal" onClick={(e) => e.stopPropagation()}>
        <div className="parca-bulk-foto-modal__header">
          <div className="parca-bulk-foto-modal__head-icon" aria-hidden>
            <i className="fas fa-images" />
          </div>
          <div className="parca-bulk-foto-modal__head-text">
            <h2 id="parca-bulk-foto-title">Seçilenlere foto ekle</h2>
            <p className="parca-bulk-foto-modal__subtitle">
              {selectedCount} parçaya uygulanacak
            </p>
          </div>
          <button
            type="button"
            className="close-btn parca-bulk-foto-modal__close"
            onClick={onClose}
            aria-label="Kapat"
            disabled={confirmBusy}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="parca-bulk-foto-modal__body">
          <ContentFotoUploadZone
            heading="Parça fotoğrafı"
            sub={`${selectedCount} parçaya uygulanacak`}
            previewUrl={previewUrl}
            hasExistingFoto={false}
            hasNewFoto={hasNewFoto}
            canSelectFile={!confirmBusy}
            onFileSelected={onFileSelected}
            onRemoveExisting={() => {}}
            onClearNew={onClearFile}
          />
        </div>

        <div className="parca-bulk-foto-modal__footer">
          <button
            type="button"
            className="secondary-btn"
            disabled={confirmBusy}
            onClick={onClose}
          >
            İptal
          </button>
          <button
            type="button"
            className="primary-btn"
            disabled={confirmBusy || !hasNewFoto}
            onClick={onConfirm}
          >
            {confirmBusy ? (
              <>
                <i className="fas fa-spinner fa-spin" aria-hidden />
                Uygulanıyor…
              </>
            ) : (
              <>
                <i className="fas fa-check" aria-hidden />
                Uygula
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
